import React, { CSSProperties } from "react";
import { Link as RouterLink } from "react-router-dom";
import { ComposantAllProps } from "../common";
import { Pojo } from "types/Galaxy";

const linkWrapperStyle: CSSProperties = { width: "100%", height: "100%" };

interface LinkProps extends ComposantAllProps {
  urlTemplate?: string;
  entity?: Pojo;
  link?: string;
  title?: string;
}

const Link = React.memo<LinkProps>(
  ({ value, onContextMenu, urlTemplate, entity, link, title, ...rest }) => {
    const isValidPath = (string: string) => {
      return string && (string.startsWith("/") || !string.includes("://"));
    };

    const isExternalUrl = (string: string) => {
      // Vérifier si c'est une URL externe
      try {
        const url = new URL(string);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (_) {
        return false;
      }
    };

    const replaceVariables = (template: string, entityData: Pojo) => {
      if (!template || !entityData) return template;
      return template.replace(/:([^./]+)\.([^./]+)/g, (match, entityName, property) => {
        const value = entityData[entityName];

        return value != null ? String(value) : match;
      });
    };
    const parseTemplate = (template: string) => {
      try {
        const parsed = JSON.parse(template);
        if (parsed.link || parsed.title) {
          return {
            url: parsed.link,
            displayTitle: parsed.title
          };
        }
      } catch (e) {}
      return {
        url: template,
        displayTitle: null
      };
    };

    let urlToUse = link;
    let titleToUse = title;

    if (urlTemplate && !link && !title) {
      const parsed = parseTemplate(urlTemplate);
      urlToUse = parsed.url;
      titleToUse = parsed.displayTitle;
    }

    if (!urlToUse) {
      return (
        <div className="flex items-center" style={linkWrapperStyle} onContextMenu={onContextMenu}>
          <span className="has-text-grey">-</span>
        </div>
      );
    }

    // Traiter les variables dans l'URL et le titre
    const processedUrl = entity ? replaceVariables(urlToUse, entity) : urlToUse;
    const processedTitle = entity && titleToUse ? replaceVariables(titleToUse, entity) : titleToUse;

    // Déterminer le texte à afficher (titre s'il existe, sinon URL)
    const displayText = processedTitle || processedUrl;

    // Si c'est une URL externe, afficher comme un lien externe
    if (isExternalUrl(processedUrl)) {
      console.log("Rendering external link with href:", processedUrl);
      return (
        <div className="flex items-center" style={linkWrapperStyle} onContextMenu={onContextMenu}>
          <a
            href={processedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="has-text-link"
            style={{ textDecoration: "underline" }}
            onClick={e => {
              console.log("External link clicked!", processedUrl);
              e.stopPropagation();
            }}
          >
            {displayText}
          </a>
        </div>
      );
    }

    if (isValidPath(processedUrl)) {
      return (
        <div className="flex items-center" style={linkWrapperStyle} onContextMenu={onContextMenu}>
          <RouterLink
            to={processedUrl}
            className="has-text-link"
            style={{ textDecoration: "underline" }}
            onClick={e => {
              console.log("RouterLink clicked!", processedUrl);
              e.stopPropagation();
            }}
          >
            {displayText}
          </RouterLink>
        </div>
      );
    }

    return (
      <div className="flex items-center" style={linkWrapperStyle} onContextMenu={onContextMenu}>
        <span>{displayText}</span>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.value === nextProps.value &&
      prevProps.link === nextProps.link &&
      prevProps.title === nextProps.title &&
      prevProps.urlTemplate === nextProps.urlTemplate
    );
  }
);

export default Link;
